// Complete IPA data for phonology editor
// Basic mode shows common phonemes, Advanced mode shows all

// Pulmonic Consonants - organized by manner (rows) and place (columns)
export const PLACES_OF_ARTICULATION = [
  'bilabial',
  'labiodental', 
  'dental',
  'alveolar',
  'postalveolar',
  'retroflex',
  'palatal',
  'velar',
  'uvular',
  'pharyngeal',
  'glottal'
];

export const PLACES_BASIC = [
  'bilabial',
  'labiodental',
  'dental',
  'alveolar',
  'postalveolar',
  'palatal',
  'velar',
  'glottal'
];

export const MANNERS_OF_ARTICULATION = [
  'plosive',
  'nasal',
  'trill',
  'tap/flap',
  'fricative',
  'lateral fricative',
  'approximant',
  'lateral approximant'
];

export const MANNERS_BASIC = [
  'plosive',
  'nasal',
  'fricative',
  'approximant',
  'lateral approximant'
];

// Full pulmonic consonant chart
// Each entry: { symbol, place, manner, voiced }
export const PULMONIC_CONSONANTS = [
  // Plosives
  { symbol: 'p', place: 'bilabial', manner: 'plosive', voiced: false },
  { symbol: 'b', place: 'bilabial', manner: 'plosive', voiced: true },
  { symbol: 't', place: 'alveolar', manner: 'plosive', voiced: false },
  { symbol: 'd', place: 'alveolar', manner: 'plosive', voiced: true },
  { symbol: 'ʈ', place: 'retroflex', manner: 'plosive', voiced: false },
  { symbol: 'ɖ', place: 'retroflex', manner: 'plosive', voiced: true },
  { symbol: 'c', place: 'palatal', manner: 'plosive', voiced: false },
  { symbol: 'ɟ', place: 'palatal', manner: 'plosive', voiced: true },
  { symbol: 'k', place: 'velar', manner: 'plosive', voiced: false },
  { symbol: 'ɡ', place: 'velar', manner: 'plosive', voiced: true },
  { symbol: 'q', place: 'uvular', manner: 'plosive', voiced: false },
  { symbol: 'ɢ', place: 'uvular', manner: 'plosive', voiced: true },
  { symbol: 'ʔ', place: 'glottal', manner: 'plosive', voiced: false },
  
  // Nasals
  { symbol: 'm', place: 'bilabial', manner: 'nasal', voiced: true },
  { symbol: 'ɱ', place: 'labiodental', manner: 'nasal', voiced: true },
  { symbol: 'n', place: 'alveolar', manner: 'nasal', voiced: true },
  { symbol: 'ɳ', place: 'retroflex', manner: 'nasal', voiced: true },
  { symbol: 'ɲ', place: 'palatal', manner: 'nasal', voiced: true },
  { symbol: 'ŋ', place: 'velar', manner: 'nasal', voiced: true },
  { symbol: 'ɴ', place: 'uvular', manner: 'nasal', voiced: true },
  
  // Trills
  { symbol: 'ʙ', place: 'bilabial', manner: 'trill', voiced: true },
  { symbol: 'r', place: 'alveolar', manner: 'trill', voiced: true },
  { symbol: 'ʀ', place: 'uvular', manner: 'trill', voiced: true },
  
  // Taps/Flaps
  { symbol: 'ⱱ', place: 'labiodental', manner: 'tap/flap', voiced: true },
  { symbol: 'ɾ', place: 'alveolar', manner: 'tap/flap', voiced: true },
  { symbol: 'ɽ', place: 'retroflex', manner: 'tap/flap', voiced: true },
  
  // Fricatives
  { symbol: 'ɸ', place: 'bilabial', manner: 'fricative', voiced: false },
  { symbol: 'β', place: 'bilabial', manner: 'fricative', voiced: true },
  { symbol: 'f', place: 'labiodental', manner: 'fricative', voiced: false },
  { symbol: 'v', place: 'labiodental', manner: 'fricative', voiced: true },
  { symbol: 'θ', place: 'dental', manner: 'fricative', voiced: false },
  { symbol: 'ð', place: 'dental', manner: 'fricative', voiced: true },
  { symbol: 's', place: 'alveolar', manner: 'fricative', voiced: false },
  { symbol: 'z', place: 'alveolar', manner: 'fricative', voiced: true },
  { symbol: 'ʃ', place: 'postalveolar', manner: 'fricative', voiced: false },
  { symbol: 'ʒ', place: 'postalveolar', manner: 'fricative', voiced: true },
  { symbol: 'ʂ', place: 'retroflex', manner: 'fricative', voiced: false },
  { symbol: 'ʐ', place: 'retroflex', manner: 'fricative', voiced: true },
  { symbol: 'ç', place: 'palatal', manner: 'fricative', voiced: false },
  { symbol: 'ʝ', place: 'palatal', manner: 'fricative', voiced: true },
  { symbol: 'x', place: 'velar', manner: 'fricative', voiced: false },
  { symbol: 'ɣ', place: 'velar', manner: 'fricative', voiced: true },
  { symbol: 'χ', place: 'uvular', manner: 'fricative', voiced: false },
  { symbol: 'ʁ', place: 'uvular', manner: 'fricative', voiced: true },
  { symbol: 'ħ', place: 'pharyngeal', manner: 'fricative', voiced: false },
  { symbol: 'ʕ', place: 'pharyngeal', manner: 'fricative', voiced: true },
  { symbol: 'h', place: 'glottal', manner: 'fricative', voiced: false },
  { symbol: 'ɦ', place: 'glottal', manner: 'fricative', voiced: true },
  
  // Lateral Fricatives
  { symbol: 'ɬ', place: 'alveolar', manner: 'lateral fricative', voiced: false },
  { symbol: 'ɮ', place: 'alveolar', manner: 'lateral fricative', voiced: true },
  
  // Approximants
  { symbol: 'ʋ', place: 'labiodental', manner: 'approximant', voiced: true },
  { symbol: 'ɹ', place: 'alveolar', manner: 'approximant', voiced: true },
  { symbol: 'ɻ', place: 'retroflex', manner: 'approximant', voiced: true },
  { symbol: 'j', place: 'palatal', manner: 'approximant', voiced: true },
  { symbol: 'ɰ', place: 'velar', manner: 'approximant', voiced: true },
  
  // Lateral Approximants
  { symbol: 'l', place: 'alveolar', manner: 'lateral approximant', voiced: true },
  { symbol: 'ɭ', place: 'retroflex', manner: 'lateral approximant', voiced: true },
  { symbol: 'ʎ', place: 'palatal', manner: 'lateral approximant', voiced: true },
  { symbol: 'ʟ', place: 'velar', manner: 'lateral approximant', voiced: true },
];

// Common consonants for basic mode
export const BASIC_CONSONANT_SYMBOLS = [
  'p', 'b', 't', 'd', 'k', 'ɡ', 'ʔ',
  'm', 'n', 'ŋ',
  'f', 'v', 'θ', 'ð', 's', 'z', 'ʃ', 'ʒ', 'h',
  'ɹ', 'j', 'w',
  'l'
];

export const PULMONIC_CONSONANTS_BASIC = PULMONIC_CONSONANTS.filter(
  c => BASIC_CONSONANT_SYMBOLS.includes(c.symbol)
);

// Add 'w' which is a coarticulated consonant (labial-velar)
export const ADDITIONAL_BASIC_CONSONANTS = [
  { symbol: 'w', place: 'velar', manner: 'approximant', voiced: true, notes: 'labial-velar' }
];

// Non-pulmonic consonants
export const NON_PULMONIC_CONSONANTS = {
  clicks: [
    { symbol: 'ʘ', subtype: 'click', place: 'bilabial' },
    { symbol: 'ǀ', subtype: 'click', place: 'dental' },
    { symbol: 'ǃ', subtype: 'click', place: 'alveolar' },
    { symbol: 'ǂ', subtype: 'click', place: 'palatoalveolar' },
    { symbol: 'ǁ', subtype: 'click', place: 'alveolar lateral' },
  ],
  implosives: [
    { symbol: 'ɓ', subtype: 'implosive', place: 'bilabial', voiced: true },
    { symbol: 'ɗ', subtype: 'implosive', place: 'dental/alveolar', voiced: true },
    { symbol: 'ʄ', subtype: 'implosive', place: 'palatal', voiced: true },
    { symbol: 'ɠ', subtype: 'implosive', place: 'velar', voiced: true },
    { symbol: 'ʛ', subtype: 'implosive', place: 'uvular', voiced: true },
  ],
  ejectives: [
    { symbol: 'pʼ', subtype: 'ejective', place: 'bilabial' },
    { symbol: 'tʼ', subtype: 'ejective', place: 'alveolar' },
    { symbol: 'kʼ', subtype: 'ejective', place: 'velar' },
    { symbol: 'sʼ', subtype: 'ejective', place: 'alveolar fricative' },
  ]
};

// Vowels - organized by height and backness
export const VOWEL_HEIGHTS = ['close', 'near-close', 'close-mid', 'mid', 'open-mid', 'near-open', 'open'];
export const VOWEL_HEIGHTS_BASIC = ['close', 'near-close', 'close-mid', 'mid', 'open-mid', 'near-open', 'open'];

export const VOWEL_BACKNESS = ['front', 'central', 'back'];

// Full vowel chart
// Each entry: { symbol, height, backness, rounded }
export const VOWELS = [
  // Close
  { symbol: 'i', height: 'close', backness: 'front', rounded: false },
  { symbol: 'y', height: 'close', backness: 'front', rounded: true },
  { symbol: 'ɨ', height: 'close', backness: 'central', rounded: false },
  { symbol: 'ʉ', height: 'close', backness: 'central', rounded: true },
  { symbol: 'ɯ', height: 'close', backness: 'back', rounded: false },
  { symbol: 'u', height: 'close', backness: 'back', rounded: true },
  
  // Near-close
  { symbol: 'ɪ', height: 'near-close', backness: 'front', rounded: false },
  { symbol: 'ʏ', height: 'near-close', backness: 'front', rounded: true },
  { symbol: 'ʊ', height: 'near-close', backness: 'back', rounded: true },
  
  // Close-mid
  { symbol: 'e', height: 'close-mid', backness: 'front', rounded: false },
  { symbol: 'ø', height: 'close-mid', backness: 'front', rounded: true },
  { symbol: 'ɘ', height: 'close-mid', backness: 'central', rounded: false },
  { symbol: 'ɵ', height: 'close-mid', backness: 'central', rounded: true },
  { symbol: 'ɤ', height: 'close-mid', backness: 'back', rounded: false },
  { symbol: 'o', height: 'close-mid', backness: 'back', rounded: true },
  
  // Mid
  { symbol: 'ə', height: 'mid', backness: 'central', rounded: false },
  
  // Open-mid
  { symbol: 'ɛ', height: 'open-mid', backness: 'front', rounded: false },
  { symbol: 'œ', height: 'open-mid', backness: 'front', rounded: true },
  { symbol: 'ɜ', height: 'open-mid', backness: 'central', rounded: false },
  { symbol: 'ɞ', height: 'open-mid', backness: 'central', rounded: true },
  { symbol: 'ʌ', height: 'open-mid', backness: 'back', rounded: false },
  { symbol: 'ɔ', height: 'open-mid', backness: 'back', rounded: true },
  
  // Near-open
  { symbol: 'æ', height: 'near-open', backness: 'front', rounded: false },
  { symbol: 'ɐ', height: 'near-open', backness: 'central', rounded: false },
  
  // Open
  { symbol: 'a', height: 'open', backness: 'front', rounded: false },
  { symbol: 'ɶ', height: 'open', backness: 'front', rounded: true },
  { symbol: 'ä', height: 'open', backness: 'central', rounded: false },
  { symbol: 'ɑ', height: 'open', backness: 'back', rounded: false },
  { symbol: 'ɒ', height: 'open', backness: 'back', rounded: true },
];

// Common vowels for basic mode
export const BASIC_VOWEL_SYMBOLS = [
  'i', 'u', 'e', 'o', 'ə', 'ɛ', 'ɔ', 'æ', 'a', 'ɑ', 'ʌ', 'ɪ', 'ʊ'
];

export const VOWELS_BASIC = VOWELS.filter(
  v => BASIC_VOWEL_SYMBOLS.includes(v.symbol)
);

// Helper function to get consonant at position
export const getConsonantAt = (consonants, place, manner, voiced) => {
  return consonants.find(
    c => c.place === place && c.manner === manner && c.voiced === voiced
  );
};

// Helper function to get vowel at position
export const getVowelAt = (vowels, height, backness, rounded) => {
  return vowels.find(
    v => v.height === height && v.backness === backness && v.rounded === rounded
  );
};

// Place labels for display
export const PLACE_LABELS = {
  'bilabial': 'Bilabial',
  'labiodental': 'Labio-dental',
  'dental': 'Dental',
  'alveolar': 'Alveolar',
  'postalveolar': 'Post-alveolar',
  'retroflex': 'Retroflex',
  'palatal': 'Palatal',
  'velar': 'Velar',
  'uvular': 'Uvular',
  'pharyngeal': 'Pharyngeal',
  'glottal': 'Glottal'
};

// Manner labels for display
export const MANNER_LABELS = {
  'plosive': 'Plosive',
  'nasal': 'Nasal',
  'trill': 'Trill',
  'tap/flap': 'Tap/Flap',
  'fricative': 'Fricative',
  'lateral fricative': 'Lat. Fricative',
  'approximant': 'Approximant',
  'lateral approximant': 'Lat. Approximant'
};

// Height labels for display
export const HEIGHT_LABELS = {
  'close': 'Close',
  'near-close': 'Near-close',
  'close-mid': 'Close-mid',
  'mid': 'Mid',
  'open-mid': 'Open-mid',
  'near-open': 'Near-open',
  'open': 'Open'
};

// Backness labels for display
export const BACKNESS_LABELS = {
  'front': 'Front',
  'central': 'Central',
  'back': 'Back'
};
